import $ from 'jquery';

import AutoNumeric from 'autonumeric';

const supportedFormats = {
  'dotDecimal-commaSeparator': {
    dotDecimalCharCommaSeparator: true,
  }, // example output: 1,003,450.22,
  'noneDecimal-commaSeparator': {
    dotDecimalCharCommaSeparator: true,
    decimalPlaces: 0,
  }, // example output: 1,003,450
};

const DEFAULT_SETTINGS = {
  modifyValueOnWheel: false,
  styleRules: {
    userDefined: [{
      callback: function saveUnformatedValue(event) {
        $(event.domElement).attr('data-autoformat-unformat-val', event.getNumericString());
      },
    }],
  },
};

const formattedInputs = {};

export default function initInputFormatter(fields = 'input[type="text"][data-autoformat]') {
  $(fields).each(function formatInput(idx, element) {
    const $element = $(element);
    const inputName = $element.attr('name');
    const format = $element.attr('data-autoformat');
    const isFormatSupported = supportedFormats[format] !== undefined;

    if (isFormatSupported) {
      formattedInputs[inputName] = new AutoNumeric(element, getSettings($element, format));
    } else {
      console.error(`Given format for input[name='${inputName}'] is not supported!`);
    }
  });
}

function getSettings($element, format) {
  const settings = Object.assign({}, DEFAULT_SETTINGS);

  if ($element.is('[data-autoformat-min-value]')) {
    const minValue = $element.attr('data-autoformat-min-value');

    Object.assign(settings, {
      minimumValue: minValue,
      overrideMinMaxLimits: minValue > 0 ? 'ceiling' : null,
    });
  }

  if ($element.is('[data-autoformat-max-value]')) {
    Object.assign(settings, {
      maximumValue: $element.attr('data-autoformat-max-value'),
    });
  }

  return Object.assign({}, supportedFormats[format], settings);
}

export function getFormattedInputs() {
  return formattedInputs;
}

